<template>
    <div class="home-section">
        <img class="picture" :src="PictureUrl">

        <h4 v-html="Title"></h4>
        <h5 v-html="SubTitle"></h5>
        <p>{{ DateStart.toLocaleString('fr-FR',{year: 'numeric', month: 'long', day: 'numeric'}) }} - {{ DateEnd.toLocaleString('fr-FR',{year: 'numeric', month: 'long', day: 'numeric'}) }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            Title: String,
            SubTitle: String,
            DateStart: Date,
            DateEnd: Date,
            PictureUrl: String
        },
    }
</script>

